// removed by extract-text-webpack-plugin
module.exports = {"dec":"_3uLDdO_Dbm7t-qFxlazkvj","img":"_2U3rLFF1VwnrT9OKsDfzO5","tipsIcon":"_2JHBsxfrIT81UD5UmwVvWK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TipsView/TipsView.module.less
// module id = 754
// module chunks = 0